import { listarInstituciones } from '../catalogos/cliente-catalogos.js'
import { listarActores } from '../actores/cliente-actores.js'
import { listarExpedientes } from '../expedientes/cliente-expedientes.js'
import { ErrorApi } from '../identidad/cliente-identidad.js'
import { notificar } from '../fundacion/alertas.js'
import {
  crearObservacionInstitucional,
  listarObservacionesInstitucionales,
  type FiltrosObservacionesInstitucionales,
} from './cliente-observaciones-institucionales.js'
const elemento = <T extends Element>(selector: string): T => {
  const dato = document.querySelector<T>(selector)
  if (!dato) throw new Error(`No existe ${selector}`)
  return dato
}
const error = (dato: unknown) =>
  dato instanceof ErrorApi ? dato.message : 'No fue posible completar la operación.'
let filtrosActuales: FiltrosObservacionesInstitucionales = {}
let paginaActual = 1
export async function mostrarObservacionesInstitucionales(roles: string[] = []): Promise<void> {
  filtrosActuales = {}
  paginaActual = 1
  elemento('#vista-observaciones-institucionales').classList.remove('d-none')
  elemento('#descripcion-observaciones-institucionales').textContent = roles.includes('ASESOR')
    ? 'Registre visitas y observaciones de las instituciones asignadas.'
    : 'Consulte las observaciones institucionales disponibles para su audiencia autorizada.'
  elemento('#tarjeta-formulario-observacion-institucional').classList.toggle(
    'd-none',
    !roles.includes('ASESOR'),
  )
  const selectorInstitucion = elemento<HTMLSelectElement>('#filtro-institucion-observacion')
  const selectorAsesor = elemento<HTMLSelectElement>('#filtro-asesor-observacion')
  elemento<HTMLInputElement>('#filtro-desde-observacion').value = ''
  elemento<HTMLInputElement>('#filtro-hasta-observacion').value = ''
  selectorInstitucion.replaceChildren(new Option('Todas las instituciones', ''))
  selectorAsesor.replaceChildren(new Option('Todos los asesores', ''))
  if (
    roles.some((rol) => ['ASESOR', 'COORDINADOR_GENERAL', 'COORDINADOR_ASESORES'].includes(rol))
  ) {
    const instituciones = (await listarInstituciones()).datos
    selectorInstitucion.append(
      ...instituciones
        .filter((institucion) => institucion.estado === 'ACTIVO')
        .map((institucion) => new Option(institucion.nombre, institucion.id)),
    )
  }
  if (roles.some((rol) => ['COORDINADOR_GENERAL', 'COORDINADOR_ASESORES'].includes(rol))) {
    const asesores = (await listarActores('ASESOR')).datos
    selectorAsesor.append(
      ...asesores.map((asesor) => new Option(`${asesor.nombres} ${asesor.apellidos}`, asesor.id)),
    )
  }
  if (!roles.includes('ASESOR')) {
    await cargarLista()
    return
  }
  const instituciones = (await listarInstituciones()).datos
  const selector = elemento<HTMLSelectElement>('#institucion-observacion-institucional')
  selector.replaceChildren(
    new Option('Seleccione…', ''),
    ...instituciones.filter((i) => i.estado === 'ACTIVO').map((i) => new Option(i.nombre, i.id)),
  )
  const expedientes = (await listarExpedientes()).datos
  const listaEstudiantes = elemento('#estudiantes-audiencia-observacion')
  listaEstudiantes.replaceChildren(
    ...expedientes.map((e) => {
      const label = document.createElement('label')
      label.className = 'form-check'
      label.innerHTML = `<input class="form-check-input" type="checkbox" value="${e.estudianteUsuarioId}"><span class="form-check-label">${e.estudianteNombre}</span>`
      return label
    }),
  )
  await cargarLista()
}
async function cargarLista(): Promise<void> {
  const lista = elemento('#lista-observaciones-institucionales')
  const respuesta = await listarObservacionesInstitucionales({
    ...filtrosActuales,
    pagina: paginaActual,
  })
  const datos = respuesta.datos
  lista.replaceChildren(
    ...datos.map((dato) => {
      const articulo = document.createElement('article')
      articulo.className = 'card mb-3'
      const cuerpo = document.createElement('div')
      cuerpo.className = 'card-body'
      const titulo = document.createElement('h3')
      titulo.className = 'h6'
      titulo.textContent = dato.asunto
      const metadatos = document.createElement('p')
      metadatos.className = 'small text-muted mb-2'
      metadatos.textContent = `${dato.fecha} · ${dato.institucionNombre} · ${dato.asesorNombre}`
      const texto = document.createElement('p')
      texto.className = 'mb-2 texto-con-saltos'
      texto.textContent = dato.observacion
      const audiencia = document.createElement('p')
      audiencia.className = 'small text-muted mb-0'
      audiencia.textContent = `Visible para: ${dato.audienciaRoles
        .map(
          (rol) =>
            ({
              COORDINADOR_GENERAL: 'Coordinador General',
              COORDINADOR_ASESORES: 'Coordinador de Asesores',
              TITULAR: 'Titular vinculado',
              ESTUDIANTE: 'Estudiantes seleccionados',
            })[rol] ?? rol,
        )
        .join(', ')}`
      cuerpo.append(titulo, metadatos, texto, audiencia)
      articulo.append(cuerpo)
      return articulo
    }),
  )
  elemento('#vacio-observaciones-institucionales').classList.toggle('d-none', datos.length > 0)
  const paginacion = elemento<HTMLElement>('#paginacion-observaciones-institucionales')
  paginacion.classList.toggle('d-none', respuesta.paginacion.paginas <= 1)
  const listaPaginas = paginacion.querySelector('ul')!
  listaPaginas.replaceChildren()
  for (let pagina = 1; pagina <= respuesta.paginacion.paginas; pagina += 1) {
    const item = document.createElement('li')
    item.className = `page-item ${pagina === respuesta.paginacion.pagina ? 'active' : ''}`
    const boton = document.createElement('button')
    boton.className = 'page-link'
    boton.type = 'button'
    boton.textContent = String(pagina)
    boton.disabled = pagina === respuesta.paginacion.pagina
    boton.addEventListener('click', () => {
      paginaActual = pagina
      void cargarLista().catch((e: unknown) => notificar(error(e), 'error'))
    })
    item.append(boton)
    listaPaginas.append(item)
  }
}
elemento<HTMLFormElement>('#formulario-observacion-institucional').addEventListener(
  'submit',
  (evento) => {
    evento.preventDefault()
    const roles = Array.from(
      document.querySelectorAll<HTMLInputElement>('[name="audiencia-observacion"]:checked'),
    ).map((c) => c.value)
    const estudiantes = Array.from(
      document.querySelectorAll<HTMLInputElement>(
        '#estudiantes-audiencia-observacion input:checked',
      ),
    ).map((c) => c.value)
    const formulario = evento.currentTarget as HTMLFormElement
    if (!formulario.checkValidity() || !roles.length) return
    if (roles.includes('ESTUDIANTE') && !estudiantes.length) {
      notificar('Seleccione al menos un estudiante para esta audiencia.', 'warning')
      return
    }
    void crearObservacionInstitucional({
      institucionId: elemento<HTMLSelectElement>('#institucion-observacion-institucional').value,
      asunto: elemento<HTMLInputElement>('#asunto-observacion-institucional').value,
      observacion: elemento<HTMLTextAreaElement>('#texto-observacion-institucional').value,
      audienciaRoles: roles,
      audienciaEstudiantesIds: estudiantes,
    })
      .then(() => {
        formulario.reset()
        return cargarLista()
      })
      .then(() => notificar('Observación institucional registrada.', 'success'))
      .catch((e: unknown) => notificar(error(e), 'error'))
  },
)

elemento<HTMLFormElement>('#formulario-filtros-observaciones-institucionales').addEventListener(
  'submit',
  (evento) => {
    evento.preventDefault()
    filtrosActuales = {
      institucionId: elemento<HTMLSelectElement>('#filtro-institucion-observacion').value,
      asesorUsuarioId: elemento<HTMLSelectElement>('#filtro-asesor-observacion').value,
      desde: elemento<HTMLInputElement>('#filtro-desde-observacion').value,
      hasta: elemento<HTMLInputElement>('#filtro-hasta-observacion').value,
    }
    paginaActual = 1
    void cargarLista().catch((e: unknown) => notificar(error(e), 'error'))
  },
)
